import {
    NinchatActionType,
    NinchatDescribeTagAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const describeTag = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatDescribeTagAction}`,
    async (arg: NinchatActionParams<NinchatDescribeTagAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatDescribeTagAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
